import { Outlet } from 'react-router-dom';

import SalesConciergeWidget from '../components/SalesConciergeWidget';
import WedgeFooter from '../components/WedgeFooter';
import WedgeHeader from '../components/WedgeHeader';
import { useReferralAttribution } from '../referral';
import type { WebsiteV2OutletContext } from './context';

export function WebsiteV2Layout() {
  const referralState = useReferralAttribution();

  const context: WebsiteV2OutletContext = {
    referral: referralState.attribution,
    isReferral: referralState.isReferral,
    hasHighConfidenceReferral: referralState.hasHighConfidenceReferral,
    showFallbackReferralField: referralState.showFallbackReferralField,
  };

  return (
    <div className="min-h-screen bg-[#f7f2ea] text-slate-950">
      <WedgeHeader />
      <Outlet context={context} />
      <WedgeFooter />
      <SalesConciergeWidget referral={referralState.attribution} />
    </div>
  );
}

export default WebsiteV2Layout;
